import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type RoleImpactedUsersFetchFailedAction = {
	type: 'ROLE_IMPACTED_USERS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): RoleImpactedUsersFetchFailedAction => ({
	type: 'ROLE_IMPACTED_USERS_FETCH_FAILED',
	payload,
});
